var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dialogModel',{attrs:{"title":"协议","visible":_vm.dialogAgr,"footer":false},on:{"handleClose":_vm.handleClose}},[_c('div',{staticClass:"checkbox-box firm-clickable",on:{"click":function($event){$event.stopPropagation();}}},[_c('el-checkbox',{model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }